

































































































































import { Component, Vue } from "vue-property-decorator";
import * as TWEEN from "@tweenjs/tween.js";
const BarProps = Vue.extend({
  props: {
    barData: Object,
  },
});
@Component<Bar>({})
export default class Bar extends BarProps {
  private tween: any = null;
  public setHeart(val: number = 0) {
    for (let i = 0; i < 3; i++) {
      const heart: any = this.$refs["heart" + i];
      const heartOff: any = this.$refs["heart" + i + "_off"];
      if (i < val) {
        heart.setAttribute("display", "auto");
        heartOff.setAttribute("display", "none");
      } else {
        heart.setAttribute("display", "none");
        heartOff.setAttribute("display", "auto");
      }
    }
  }
  private infoIndex = 0;
  public setInfo(idx: number) {
    const infoText: any = this.$refs.infoText;
    clearInterval(this.infoIndex);
    if (idx == 0) {
      infoText.textContent = "";
      return;
    }
    infoText.textContent = this.$i18n.t("message.info" + idx);
    if (idx == 1) {
      return;
    }
    this.infoIndex = setInterval(() => {
      infoText.textContent = "";
    }, 2000);
  }
  public setProgress(val: number = 0, str: string) {
    const barText: any = this.$refs.barText;
    barText.textContent = str;
    let barWidth = (val / 1500000) * 550;
    if (barWidth > 550) {
      barWidth = 550;
    }
    const progressBar: any = this.$refs.progressBar;
    progressBar.setAttribute("width", barWidth);

    if (barWidth == 550 && this.tween == null) {
      const filter: any = this.$refs.hue1feGaussianBlur;
      const va = { val: 0 };
      this.tween = new TWEEN.Tween(va)
        .to({ val: 20 }, 1000)
        .repeat(Infinity)
        .yoyo(true)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onUpdate(function () {
          filter.setAttribute("stdDeviation", va.val);
        })
        .start();
    }
  }
  public data() {
    return {
      datas: this.barData,
    };
  }
}
